import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { email } from '@config';
import { navDelay, loaderDelay } from '@utils';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;

  h1 {
    margin: 0 0 30px 4px;
    color: var(--john-text-pretty);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--john-text-moderate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 500px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Value = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hello world, my name is</h1>;
  const two = <h2 className="big-heading">Tung-Duong "John" Mai.</h2>;
  const three = <h3 className="big-heading">I code and build softwares.</h3>;
  const four =  <><br></br><h2 className>My values</h2></>
  const five = (
    <ol>
    <ul>
      <p><a>Family</a></p>
      <li>Buy gifts for family when I received my first salary and bonus</li>
      <li>Save paid leaves to visit family every Lunar New Year</li>
    </ul>

    <ul>
      <p><a>Health</a></p>
        <li> Go to Samsung Gym ( <a>hopefully T-T</a>) </li> 
        <li> Eat healthy (<a>BUT delicious</a>) food. </li>
        <li> Go to work <a>on FOOT</a> </li>
    </ul>
    
    <ul>
      <p><a>Achievement</a></p>
      <li>Try my best to make my work useful and rewarded. Get rewards and regconition in company and great feedback from users.</li> 
    </ul>
    
    <ul>
      <p><a>Freedom</a></p>
        <li>Continue to believe in myself and my value.</li>
        <li>Keep walking (it makes me feel the freedom somehow) </li>
    </ul>
    
    <ul>
      <p><a>Responsibility</a></p>
        <li>Complete my work to the best of my ability, diligently contribute to the team </li>
        <li>Try to help other people.</li>
    </ul>
    
    <ul>
      <p><a>Competency</a></p>
      <li>Improve my skills constantly and become expert in my field(s).    </li>
    </ul>
    </ol>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      <TransitionGroup component={null}>
        {isMounted &&
          items.map((item, i) => (
            <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
              <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
            </CSSTransition>
          ))}
      </TransitionGroup>
    </StyledHeroSection>
  );
};

export default Value;
